import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import CustomStore from 'devextreme/data/custom_store';
import { NTECH_API } from './../app.api';
import { GridConfig, adicionaIconesGrid, calculaAlturaGrid } from './../app.config';
import { DxDataGridModule, DxDataGridComponent } from 'devextreme-angular';
import { ProtocoloTipoService } from '../protocolo-tipo/protocolo-tipo.service';

@Component({
  selector: 'ntc-protocolo-assunto',
  templateUrl: './protocolo-assunto.component.html',
  styleUrls: ['./protocolo-assunto.component.css']
})
export class ProtocoloAssuntoComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  colunasGridProtocoloAssunto = null;
  protocoloAssunto = null;
  alturaGrid = null;
  listaProtocoloTipo = [];

  editOptionsGridProtocoloAssunto = {
    mode: GridConfig.gridMode,
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    popup: {
      title: 'Protocolo Assunto',
      showTitle: true
    }
  };

  constructor(
    @Inject(Http) http: Http,
    private protocoloTipoService: ProtocoloTipoService
  ) {
    this.protocoloAssunto = new CustomStore({
      insert: function (values) {
        return http.post(`${NTECH_API}/protocolo-assunto/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/protocolo-assunto/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/protocolo-assunto/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/protocolo-assunto/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });
  }

  montaColunasGrid = function (){
    this.colunasGridProtocoloAssunto = [
      {
        dataField: 'Id',
        dataType: 'string',
        caption: 'ID',
        editorOptions: { disabled: true }
      },
      {
        dataField: 'DescricaoProtocoloAssunto',
        dataType: 'string',
        caption: 'Descrição',
        validationRules: [{
          type: 'required',
          message: 'Descrição é obrigatória.'
        }]
      },
      {
        dataField: 'IdProtocoloTipo',
        dataType: 'string',
        caption: 'Tipo do Protocolo',
        validationRules: [{
          type: 'required',
          message: 'Tipo do Protocolo é obrigatório.'
        }],
        lookup: {
          dataSource: this.listaProtocoloTipo,
          displayExpr: 'DescricaoProtocoloTipo',
          valueExpr: 'Id'
        }
      }
    ];
  };

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();

    this.protocoloTipoService.getProtocoloTipos().subscribe(protocoloTipos => {
      this.listaProtocoloTipo = protocoloTipos;
      this.montaColunasGrid();
    }, error => {
      this.montaColunasGrid();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/protocolo-assunto/protocolo-assunto.component.ts